export default __webpack_public_path__ + "static/media/Фос_20л.ae44f80a.jpg";